// extracted by mini-css-extract-plugin
export default {"root":"XKi2f","about":"fFsqE","container":"BI6Va","file":"j4nuj","manual":"Bd9Qc"};